import React, {Component, useState} from "react";
import * as prosConnect from "../prodect/ProsConnect"
import {deleteProject} from "../prodect/ProjectManagement"
import {
    ATTR_STAG_CH,
    ATTR_STAG,
    ATTR_STAG_TXT,
    featureLimit,
    MAX_CH_TAGS,
    FEAT_MAX_USERS,
    OBJ_TYPE_USER_ROLE,
    getActiveProject,
    ATTR_USER_ROLE,
    ROLE_INSPECT,
    OBJ_STATE_PAS,
    OBJ_STATE_ACT,
    ATTR_EXPORT_JSON,
    ATTR_IS_PICTURES_ALLOWED,
    ATTR_EXPORT_WEB_REPORT,
    ATTR_EXPORT_WEB_REPORT_ACT,
    FEAT_WEB_ACTIVE,
    FEAT_WEB_UPDATED,
    FEAT_JSON_EXPORT,
    ATTR_LOGO_FILE_NAME,
    FEAT_SET_PROJECT_LOGO,
    prosLogDt,
    ATTR_MAIN_PROJ_ID,
    ATTR_DATE_AND_TIME,
    restoreConfigStr,
    saveConfigStr,
    ATTR_PRJ_DESC,
    isValueEmpty,
    isValidColorCode,
    millisecToDatePicker,
    datePickerReturnValueToMillisec,
    ATTR_OBJ_ID,
    ATTR_IS_REPORTS_ALLOWED,
    ATTR_PROJECT_START,
    ATTR_PROJECT_END,
    getLogoThumpPath
} from "../prodect/ProsConnect";
import {STR_YES, STR_NO, STR_NO_VALUE} from "../prodect/ProsConnect";
import {prosLog} from "../prodect/ProsConnect";
import * as projectLoader from "../prodect/ProjectLoader";
import {
    getIconClass,
    makeNameFromEmail,
    formatDate,
    StyledProjectInfo,
    MULTI_COLOR_SETS, MULTI_COLOR_SET_HILITE, MULTI_COLOR_SET_GRAY, getEndOfWorkingDayTimeMs
} from "../prodect/ProsCommonUi";
import {
    prosNotificationShow,
    prosPopupClose, prosPopupCloseAll,
    prosPopupOpen,
    prosPopupOpenDynamic, prosPopupRender
} from "../prodect/ProsPopup";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import Spacer from "../components/Spacer";
import AccordionDropdown from "../components/AccordionDropdown";
import TextInput from "../components/TextInput";
import {ATTR_MAIN_PROJECT_NAME} from "../prodect/ProsConnect";
import {ATTR_AWS_PROJECT_ID} from "../prodect/ProsConnect";
import {ATTR_TEXT} from "../prodect/ProsConnect";
import {ATTR_EXPIRATION_REQUIRED, ATTR_EXPIRATION_RESTRIC_OWN, ATTR_EXPIRATION_RESTRIC_SET} from "../prodect/ProsConnect"
import {MAX_RB_OPTIONS} from "../prodect/ProsConnect";
import {ATTR_IS_TEMPLATE, ATTR_SHOW_IDENTIFIERS, ATTR_DELAY_TO_UPDATE_IDENTIFIERS} from "../prodect/ProsConnect";
import {ATTR_CUSTOMER_GROUP} from "../prodect/ProsConnect";
import PermissionManagement from "./PermissionManagement";
import ExcelImportExport from "./Excel";
import SettingLocationPictures from "./SettingLocationPictures"
import {featureEnabled, FEAT_EXCEL_EXPORT, FEAT_EXCEL_IMPORT,
    FEAT_SET_RESTRICTED_ACCESS, FEAT_SET_MANDATORY,
    FEAT_MAX_MV_OPTIONS, FEAT_MAX_ON_OFF, FEAT_MAX_MV, FEAT_MAX_TEXT_FIELDS} from "../prodect/ProsConnect";
import {setHelpContext} from "../prodect/HelpManager";
import LoadingAnimation from "../components/LoadingAnimation";
import DropdownMenu from "../components/DropdownMenu";
import ProjectDeletedDataRestore from "./ProjectDeletedDataRestore";
import FileUploader from "../components/FileUploader";
import SettingMoveProject from "./SettingMoveProject";
import WaitLongQueryCompletion from "../prodect/WaitLongQueryCompletion";
import Checkbox from "../components/Checkbox";
import RadioButton from "../components/RadioButton";
import ToggleSwitch from "../components/ToggleSwitch";
import prosAppNotif from "../prodect/ProsAppNotif";
import DatePicker from "../components/DatePicker";
import BasicModal from "../components/BasicModal";
import UiImage from "../components/UiImage";

const SEMI_COLON_REGEX = /;/g;
const MAX_COUNT_LIMITED_BY_LICENSE = 'Palvelutaso rajoittaa maksimi määrän.';

const NUMBERING_NONE = 0;
const NUMBERING_RESET = 1;
const NUMBERING_ALL = 2;

const userIconData = [
    'bug',
    'diamond',
    'hourglass',
    'idea',
    'lightning',
    'lock',
    'thumb-down',
    'thumb-up',
    'warning'
]
let selectedUserIcon = null

export default class ProjectSettings extends Component {

    onOffTags = prosConnect.getEmptyTags();
    freeTexts = prosConnect.getEmptyTags();
    multiValueTags = prosConnect.getEmptyTags();

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            dueDateMandatory: false,
            dueDateRestricted: false,
            dueDateRestrictedOwn: false,
            dueDateTime: false,
            logoFileName: undefined,
            mainProjectName: "",
            projectName: "",
            projectDescription: "",//Todo Jere: Save to server, #2.475 & 12.51
            projectStart: STR_NO_VALUE,
            projectEnd: STR_NO_VALUE,
            projectId: "",
            customerGroup: '',
            refresh: 0,
            isTemplate: false,
            showIdentifiers: false,
            delayToUpdatedIdentifiersMs: 0,
            activeSettingsPage: restoreConfigStr(prosConnect.SAVED_SETTINGS_SUBVIEW, 'settings'),
            myProdectCollegeEmail: undefined,
            hasContentChanged: false,
            numberingAction: 0,
            numberingBusy: false,
            isReorderingOptions: false,
            openColorPicker: undefined,
            editColorCode: "",
            textTypeMenuItems: undefined,
        }
        this.state[ATTR_EXPORT_WEB_REPORT_ACT] = true
        this.state[ATTR_EXPORT_WEB_REPORT] = true
        this.state[ATTR_EXPORT_JSON] = true
        this.state[ATTR_IS_PICTURES_ALLOWED] = true
        this.state[ATTR_IS_REPORTS_ALLOWED] = true
        this.myProdectCollege = undefined
        this.draggingTag = undefined
        this.draggingOption = undefined

        this.goBack = this.goBack.bind(this);
        this.notifText = this.notifText.bind(this);
    }

    async componentDidMount() {
        prosLog("ProjectSettings:componentDidMount() activeSettingsPage:", this.state.activeSettingsPage);
        await this.setUiFromProjectSettings()
        projectLoader.subscribe_notifyProjectLoad("SubProjectSettings", (ev) => this.projectLoadListener(ev))
        setHelpContext('projectSettings')
    }

    componentWillUnmount() {
        projectLoader.unsubscribe_notifyProjectLoad("SubProjectSettings")
        prosPopupCloseAll()
    }

    projectLoadListener(ev) {
        // console.log("ProjectSettings - projectLoadListener:", ev)
        switch (ev) {
            case projectLoader.SUB_PROJ_LOAD_EV_STARTED: {
                this.setState({isLoading: true})
                if (this.state.activeSettingsPage !== 'projectDeletedData') {
                    prosLog("ProjectSettings - reset view to main view when started to load project")
                    this.setActivePage("settings")
                }
                break
            }
            case projectLoader.SUB_PROJ_LOAD_EV_INFO: {
                this.setUiFromProjectSettings()
                break
            }
            default: break
        }
    }

    async setupTextFieldOptions(project) {
        const menuItems = [];
        const enumConfigs = await prosConnect.getAllEnums(project.getAttr(ATTR_CUSTOMER_GROUP))
        if(Array.isArray(enumConfigs)) {
            enumConfigs.forEach(enumConfig => {
                let enumId = enumConfig[ATTR_OBJ_ID]
                menuItems.push({value: "enum-"  + enumId, text: enumId}) // user may choose one
                menuItems.push({value: "enums-" + enumId, text: enumId + " (useita)"}) // user may choose multiple
            })
        }
        // Add other than enum types
        for (const [k, v] of Object.entries(prosConnect.TEXT_FIELD_TYPES)) {
            if (!k.startsWith("enum")) {
                menuItems.push({value: k, text: v})
            }
        }
        this.setState({textTypeMenuItems: menuItems})
    }

    setUiFromProjectSettings() {
        let project = prosConnect.getActiveProject();
        if (!project)  {
            prosConnect.prosLogErr("No active project")
        } else {
            this.setProjectLogo(project.attrs[ATTR_LOGO_FILE_NAME], false);
            this.onOffTags = project.getOnOffContent();
            this.freeTexts = project.getFreeTextContent();
            this.multiValueTags = project.getMultiValueContent();
            this.getDueDateSettings(project);
            this.setupProjectInfo(project);
            this.setupDelegate()
        }
        this.setState({
            isLoading: false,
            hasContentChanged: false
        });
    }

    setupDelegate() {
        let maxUsers = featureLimit(FEAT_MAX_USERS, 999)
        if (maxUsers === 2 && prosConnect.hasPermissionTo("editAdmin", undefined, undefined, false)) {
            // MyProdect - may grant access to an other person
            let delegateUserObjs = getActiveProject().getUserObjects()
                .filter(userObj => userObj[ATTR_USER_ROLE] === ROLE_INSPECT)
            this.myProdectCollege = delegateUserObjs.length > 0 ? delegateUserObjs[0] : {
                    obj_type: OBJ_TYPE_USER_ROLE,
                    email: '',
                    text: '',
                    user_role: ROLE_INSPECT
                }
            this.setState({myProdectCollegeEmail : this.myProdectCollege.email })
        }
    }

    refreshUi() {
        this.setState( {
            refresh: this.state.refresh+1,
            hasContentChanged: true
        });
    }

    notifText(text, warning, dismissByUser) {
        prosNotificationShow(this, text, warning, dismissByUser)
    }

    setProjectLogo(logoFileName, wasModified) {
        this.setState({
            logoFileName: logoFileName,
            hasContentChanged: this.state.hasContentChanged || wasModified
        })
    }

    deleteLogo() {
        this.setProjectLogo(STR_NO_VALUE, true)
    }

    changeLogoSettings() {
        prosPopupClose()
        this.openChangeLogoPopup()
    }

    openChangeLogoPopup() {
        if (!prosConnect.hasPermissionTo("addContent", undefined, undefined, false)) {
            return;
        }
        prosPopupOpenDynamic(this,
            'Lataa uusi logo',
            () => this.renderLogoUploader(),
        )
    }

    async saveLogoToServer(logoFile) {
        prosNotificationShow(this, "Tallennetaan..", false, false, true)
        prosLogDt('Saving new logo file', logoFile)
        let fileNameInAws = await prosConnect.startFileUpload(logoFile, false, prosConnect.S3_THUMP_FOLDER)
        prosLogDt('Project logo saved', fileNameInAws)
        prosNotificationShow(this, "Tallennettu")
        this.setProjectLogo(fileNameInAws, true)
        prosPopupClose()
    }

    renderLogoUploader() {
        if (!this.isAuthorized()) {
            return
        }
        return <FileUploader
            fileslimit={1}
            formats={['.jpg', '.jpeg', '.png']}
            callback={(file)=> this.saveLogoToServer(file[0])}
        />
    }

    renderChangeLogoButtons() {
        if (!featureEnabled(FEAT_SET_PROJECT_LOGO) || !this.isAuthorized()) {
            return null
        }
        return  <>
            <Spacer />
            <div className={"element-set"}>
                <BasicButton
                    btnClass={"2nd"}
                    label={"Vaihda logo"}
                    action={() => { this.changeLogoSettings()}}
                    icon={"image"}
                    shrink={"sm"}
                />
                <BasicButton
                    btnClass={"primary"}
                    label={"Poista logo"}
                    action={() => {
                        this.deleteLogo()
                        prosAppNotif( "Vahvista tiedoston poisto tallentamalla asetukset")
                    }}
                    icon={"delete"}
                    shrink={"md"}
                    btnType={"warning"}
                />
            </div>
        </>
    }

    renderProjectLogo() {
        if (this.state.logoFileName && this.state.logoFileName !== STR_NO_VALUE) {
            let imagePath = getLogoThumpPath(this.state.logoFileName)
            return <>
                <div className={"settings-logo padding"}>
                    <UiImage
                        imageSrc={imagePath}
                        className={"flex-grow width-50_lg width-30_hd margin-auto"}
                    />
                </div>
                {this.renderChangeLogoButtons()}
            </>
        } else {
            return this.renderLogoUploader()
        }

    }

    isAuthorized(what = 'editProject') {
        return prosConnect.hasPermissionTo(what, undefined, undefined, false) &&
            prosConnect.getActiveProject().isProjectActive()
    }

    async openObsSettings() {
        let project = prosConnect.getActiveProject();
        if (project) {
            this.setState({isLoading: true})
            await this.setupTextFieldOptions(project)
            this.setState({activeSettingsPage: 'obs-settings'})
            this.setState({isLoading: false})
        }
    }

    setupProjectInfo(project) {
        let change = {
            mainProjectName: project.attrs[ATTR_MAIN_PROJECT_NAME],
            projectId: project.attrs[ATTR_AWS_PROJECT_ID],
            projectName: project.attrs[ATTR_TEXT],
            projectDescription: project.attrs[ATTR_PRJ_DESC],
            isTemplate: project.attrs[ATTR_IS_TEMPLATE] === STR_YES,
            showIdentifiers: project.attrs[ATTR_SHOW_IDENTIFIERS] !== STR_NO,
            customerGroup: project.attrs[ATTR_CUSTOMER_GROUP],
            delayToUpdatedIdentifiersMs: project.attrs.hasOwnProperty(ATTR_DELAY_TO_UPDATE_IDENTIFIERS) ?
                project.attrs[ATTR_DELAY_TO_UPDATE_IDENTIFIERS] : 0,
            projectStart: project.attrs[ATTR_PROJECT_START],
            projectEnd: project.attrs[ATTR_PROJECT_END],
        }
        function setFeatureAttr(attr, feature) {
            // Note intentionally compare !== STR_NO so that a missing parameter is decoded as "yes""
            change[attr] = project.attrs[attr] !== STR_NO && (featureEnabled(feature) || !feature)
        }
        setFeatureAttr(ATTR_EXPORT_JSON, FEAT_JSON_EXPORT)
        setFeatureAttr(ATTR_IS_PICTURES_ALLOWED, undefined)
        setFeatureAttr(ATTR_IS_REPORTS_ALLOWED, undefined)
        setFeatureAttr(ATTR_EXPORT_WEB_REPORT_ACT, FEAT_WEB_ACTIVE)
        setFeatureAttr(ATTR_EXPORT_WEB_REPORT, FEAT_WEB_UPDATED)
        if (!change[ATTR_EXPORT_WEB_REPORT]) {
            change[ATTR_EXPORT_WEB_REPORT_ACT] = false
        }
        // State default value if defined
        let defaultStateAttrName = project.stateDefaultAttrName()
        change[defaultStateAttrName] = project.getAttr(defaultStateAttrName)
        this.setState(change)
    }

    getDueDateSettings(project) {
        function booleanAttr(attr) {
            return project.attrs[attr] === STR_YES
        }
        this.setState(
            {
                dueDateMandatory: booleanAttr(ATTR_EXPIRATION_REQUIRED),
                dueDateRestricted: booleanAttr(ATTR_EXPIRATION_RESTRIC_SET),
                dueDateRestrictedOwn: booleanAttr(ATTR_EXPIRATION_RESTRIC_OWN),
                dueDateTime: booleanAttr(ATTR_DATE_AND_TIME),
            }
        )
    }

    onOffCheckboxes(chTag) {
        return <ToggleSwitch
            checked={chTag.inUse}
            disabled={!this.isAuthorized()}
            onChange={()=> {
                chTag.inUse = !chTag.inUse;
                this.refreshUi();
            }}
        />
    }

    renderRestrictedOnOff(chTag) {
        if (!featureEnabled(FEAT_SET_RESTRICTED_ACCESS)) {
            return null
        }
        return <Checkbox
            checked={chTag.limitedEdit}
            disabled={!this.isAuthorized()}
            onChange={() => {
                chTag.limitedEdit = !chTag.limitedEdit
                this.refreshUi()
            }}
        />
    }

    renderInUseFreeText(txt) {
        return <ToggleSwitch
            checked={txt.inUse}
            disabled={!this.isAuthorized()}
            onChange={()=> {
                txt.inUse = !txt.inUse;
                this.refreshUi();
            }}
        />
    }

    renderRestrictedFreeText(txt) {
        if (!featureEnabled(FEAT_SET_RESTRICTED_ACCESS)) {
            return null
        }

        return (
            <Checkbox
                checked={txt.limitedEdit}
                disabled={!this.isAuthorized()}
                onChange={() => {
                    txt.limitedEdit = !txt.limitedEdit;
                    this.refreshUi();
                }}
            />
        )
    }

    renderMandatoryFreeText(txt) {
        if (!featureEnabled(FEAT_SET_MANDATORY)) {
            return null
        }

        return (
            <Checkbox
                checked={txt.isMandatory}
                disabled={!this.isAuthorized()}
                onChange={() => {
                    txt.isMandatory = !txt.isMandatory;
                    this.refreshUi();
                }}
            />
        )
    }

    handleEnumValueChange(val, txt) {
        txt.textType = val
        this.refreshUi()
    }

    renderEnumMenu(txt) {
        return <DropdownMenu
            values={this.state.textTypeMenuItems ?? []}
            currentValue={txt.textType}
            onSelect={retVal => this.handleEnumValueChange(retVal, txt)}
            className={"ui-dropdown-align-right"}
        />
    }

    renderIdentifiersSwitch() {
        return <ToggleSwitch
            label={"Näytä tunnusnumero"}
            checked={this.state.showIdentifiers}
            disabled={!this.isAuthorized()}
            onChange={()=> {
                this.setState({
                    showIdentifiers: !this.state.showIdentifiers,
                    hasContentChanged: true
                })
            }}
        />
    }

    changeInfoSharing(attr) {
        let change = {}
        change[attr] = !this.state[attr]
        if (attr === ATTR_EXPORT_WEB_REPORT && this.state[ATTR_EXPORT_WEB_REPORT]) {
            change[ATTR_EXPORT_WEB_REPORT_ACT] = false
        }
        if (attr === ATTR_EXPORT_WEB_REPORT_ACT && !this.state[ATTR_EXPORT_WEB_REPORT]) {
            change[ATTR_EXPORT_WEB_REPORT] = true
        }
        change['hasContentChanged'] = true
        this.setState(change)
    }

    renderInfoSharingSwitch(attr, feature, label) {
        if (feature === FEAT_WEB_ACTIVE && !featureEnabled(feature)) {
            return null
        }
        let disabled = !this.isAuthorized('shareProject') || (feature && !featureEnabled(feature))
        return <>
            <ToggleSwitch
                label={label}
                checked={this.state[attr]}
                disabled={disabled}
                onChange={()=> this.changeInfoSharing(attr)}
            />
            <Spacer />
        </>
    }

    renderDelayForIdAutoGeneration() {
        if(!this.state.showIdentifiers) return
        return <>
            <Spacer />
            <TextInput
                label={"Automaattisen numeroinnin viive tunteina"}
                disabled={!this.isAuthorized()}
                className={"inline width-auto"}
                value={'' + this.state.delayToUpdatedIdentifiersMs ?
                    this.state.delayToUpdatedIdentifiersMs : ''}
                isControlled={true}
                onChange={val => this.handleChangeIdGenDelay(val)}
                info={"Esim. 1 = yksi tunti, 0 = ei käytössä."}
            />
            <Spacer />
        </>
    }

    renderNumberingAction(actionId, label) {
        const actionType = this.state.numberingAction ? this.state.numberingAction : 0
        return <RadioButton
            checked={actionType === actionId}
            disabled={!this.isAuthorized()}
            text={label}
            onChange={() => this.setState({numberingAction: actionId})}
        />
    }

    executeNumbering(numberingType) {
        this.setState({ numberingBusy: true })
    }

    numberingCompleted() {
        this.setState({ numberingBusy: false })
        this.goBack()
    }

    renderResetOrAddNumbering() {
        if(!this.state.showIdentifiers) return null
        if(this.state.numberingBusy) {
            let waitText = this.state.numberingAction === NUMBERING_RESET ?
                "Poistetaan raporttien ja kirjausten tunnusnumerot..." :
                "Lisätään puuttuvia tunnusnumeroita..."
            let queryType = this.state.numberingAction === NUMBERING_RESET ?
                prosConnect.QUERY_NUMBERING_RESET: prosConnect.QUERY_NUMBERING_ALL
            return <WaitLongQueryCompletion
                waitText={waitText}
                queryId="Numbering"
                queryType={queryType}
                projectId={prosConnect.getActiveProjectID()}
                queryCompleted={()=> this.numberingCompleted()}
            />
        }
        return <>
            <h4>Toiminnot</h4>
            <div className="selection-group selection-group-radio">
                {this.renderNumberingAction(NUMBERING_ALL, 'Lisää puuttuvat tunnusnumerot kaikkiin raportteihin')}
                {this.renderNumberingAction(NUMBERING_RESET, 'Resetoi raporttien ja kirjausten numeroinnit')}
                {this.state.numberingAction ? <div className={"btn-set"}>
                        <BasicButton
                            btnClass={"2nd"}
                            label={"Peru"}
                            action={()=> this.setState({numberingAction: NUMBERING_NONE})}
                        />
                        <BasicButton
                            btnClass={"primary"}
                            label={"Jatka"}
                            action={()=> this.executeNumbering(this.state.numberingAction)}
                        />
                    </div> : null}
            </div>
        </>
    }

    changeDueDate(stateVarName) {
        let stateChangeObj = {}
        stateChangeObj[stateVarName] = !this.state[stateVarName]
        if (stateVarName === 'dueDateRestricted' && !this.state[stateVarName]) {
            stateChangeObj.dueDateRestrictedOwn = !this.state[stateVarName]
        }
        if (stateVarName === 'dueDateRestrictedOwn' && this.state[stateVarName]) {
            stateChangeObj.dueDateRestricted = !this.state[stateVarName]
        }
        stateChangeObj['hasContentChanged'] = true
        this.setState(stateChangeObj)
    }

    renderDueDateSwitch(stateVarName) {
        return (
            <Checkbox
                checked={this.state[stateVarName]}
                disabled={!this.isAuthorized()}
                onChange={() => {
                    this.changeDueDate(stateVarName)
                }}
            />
        )
    }

    handleSendNotificationBeforeDueDate(e) {
        e.preventDefault();
        let intVal = parseInt(e.target.value)
        this.setState({sendNotificationBeforeDueDate: intVal ? intVal: 0})
    }

    notifyRemoval() {
        prosNotificationShow(this, "Poistettu - peru muutokset, jos et halua poistaa.")
    }

    removeOnOffTitle(i) {
        prosPopupClose()
        this.onOffTags.tags[i].removed = true;
        this.notifyRemoval();
        this.refreshUi();
    }

    removeFreeText(i) {
        prosPopupClose()
        this.freeTexts.tags[i].removed = true;
        this.notifyRemoval();
        this.refreshUi();
    }

    removeMultiChoice(i) {
        prosPopupClose()
        let option = i;
        option.removed = true;
        this.notifyRemoval();
        this.refreshUi();
    }

    async doArchiveOrActivateProject() {
        let activeProject = prosConnect.getActiveProject()
        let noteAction = activeProject.isProjectActive() ? 'arkistoitu': 'aktivoitu'
        let newState = activeProject.isProjectActive() ? OBJ_STATE_PAS : OBJ_STATE_ACT
        let toggleProjectPids = [prosConnect.getActiveProject().getPid()]
        await prosConnect.archiveActivateProjects(toggleProjectPids, newState)
        await this.setUiFromProjectSettings()
        this.notifText('Osaprojekti ' + noteAction, false, false)
    }

    openConfirmDeleteProjectPopup() {
        prosPopupOpen(this,
            'Poista osaprojekti',
            <>
                <section>
                    <p>Oletko varma että haluat poistaa osaprojektin?</p>
                        <h3 className={"color-no-c7"}>Poistettuja tietoja ei voi palauttaa toiminnon jälkeen.</h3>
                </section>
                <footer className={"popup-footer"}>
                    <div className={"btn-set"}>
                        <CancelButton
                            action={()=> prosPopupClose()}
                        />
                        <ConfirmButton
                            btnType={"fatal"}
                            action={()=> {
                                this.deleteActiveProject()
                                prosPopupClose()
                            }}
                        />
                    </div>
                </footer>
            </>
        )
    }

    renderDeleteType() {
        const TYPE_BY_SELECTION = {
            "freeText": "teksikentän",
            "chTag": "kyllä/ei valinnan",
            "multiValue": "monivalinnan",
            "multiChoice": "vaihtoehdon"
        }
        let textByType = TYPE_BY_SELECTION[this.state.deleteType] ?
            TYPE_BY_SELECTION[this.state.deleteType]:
            TYPE_BY_SELECTION["multiChoice"]
        return <p>{"Oletko varma että haluat poistaa " + textByType + "?"}</p>
    }

    renderDeleteButton() {
        return <ConfirmButton
            btnType={"fatal"}
            action={()=> {
                switch (this.state.deleteType) {
                    case "freeText":
                        this.removeFreeText(this.state.deleteElement);
                        break;
                    case "chTag":
                        this.removeOnOffTitle(this.state.deleteElement);
                        break;
                    case "multiValue":
                        this.removeMultiValueTag(this.state.deleteElement);
                        break;
                    case "multiChoice":
                        this.removeMultiChoice(this.state.deleteElement);
                        break;
                    default:
                }
            }}
        />
    }

    openDeletePopup(type, element, self) {
        this.setState({
            deleteType: type,
            deleteElement: element,
            multiValueChoice: self,
        });
        prosPopupOpen(this,
            'Poista',
            <>
                <section>
                    {this.renderDeleteType()}
                </section>
                <footer className={"popup-footer"}>
                    <div className={"btn-set"}>
                        <CancelButton
                            action={()=> prosPopupClose()}
                        />
                        {this.renderDeleteButton()}
                    </div>
                </footer>
            </>
        )
    }

    handleAddOnOff() {
        if (this.isAuthorized()) {
            let nextOnOffTagInd = this.onOffTags.maxInd + 1;
            if (!this.limitExceededAlert(nextOnOffTagInd, prosConnect.MAX_CH_TAGS, "Liian monta kyllä/ei valintaa")) {
                this.onOffTags.tags.push( {
                    stag: ATTR_STAG_CH + nextOnOffTagInd,
                    label: "Uusi",
                    inUse: true,
                    opt2: false,
                    limitedEdit: false,
                    removed: false
                });
                this.onOffTags.maxInd = nextOnOffTagInd;
            }
            this.refreshUi();
        }
    }

    handleAddFreeText() {
        if (this.isAuthorized()) {
            let nextTagInd = this.freeTexts.maxInd + 1;
            if (!this.limitExceededAlert(nextTagInd, prosConnect.MAX_STXT_TAGS, "Liian monta tekstikenttää")) {
                let stag = ATTR_STAG_TXT + nextTagInd;
                this.freeTexts.tags.push({
                    stag: stag,
                    label: "Uusi",
                    inUse: true,
                    isMandatory: false,
                    limitedEdit: false,
                    textType: undefined,
                    removed: false
                });
                this.freeTexts.maxInd = nextTagInd;
            }
            this.refreshUi();
        }
    }

    limitExceededAlert(len, maxLen, note) {
        if (len > maxLen) {
            prosNotificationShow(this, note + ", raja " + maxLen);
            return true
        }
        return false;
    }

    filterText(txt) {
        return txt.replace(/[^a-zA-Z0-9 ()\-+:]/g, '');
    }

    handleChangeIdGenDelay(val) {
        let intVal = parseInt(val)
        this.setState({
            delayToUpdatedIdentifiersMs: intVal ? intVal: 0,
            hasContentChanged: true
        })
    }

    handleChangeChLabel(val, i) {
        let txt = val.replace(SEMI_COLON_REGEX, "");
        if (this.limitExceededAlert(txt.length, prosConnect.INPUT_TAG_MAX_LENGTH, "Liian pitkä nimi")) {
            return
        }
        this.onOffTags.tags[i].label = prosConnect.filterSpecialChars(txt);
        this.refreshUi()
    }

    handleFreeTextChange(val, txt) {
        let newTxt = val.replace(SEMI_COLON_REGEX, "");
        if (this.limitExceededAlert(newTxt.length, prosConnect.INPUT_TAG_MAX_LENGTH, "Liian pitkä nimi")) {
            return
        }
        txt.label = prosConnect.filterSpecialChars(newTxt)
        this.refreshUi()
    }

    handleMultiValueNameChange(val, mvTag) {
        let newValue = val.replace(SEMI_COLON_REGEX, "");
        if (this.limitExceededAlert(newValue.length, prosConnect.INPUT_TAG_MAX_LENGTH,"Liian pitkä nimi")) {
            return
        }
        mvTag.label = prosConnect.filterSpecialChars(newValue);
        this.refreshUi();
    }

    handleMultiValueOptionNameChange(event, option) {
        event.preventDefault();
        let newValue = event.target.value.replace(SEMI_COLON_REGEX, "");
        if (this.limitExceededAlert(event.target.value.length, prosConnect.INPUT_TAG_MAX_LENGTH, "Liian pitkä nimi")) {
            return
        }
        option.label = prosConnect.filterSpecialChars(newValue);
        this.refreshUi();
    }

    handleMultiValueColorChange(val) {
        let colorCode = val.replace(SEMI_COLON_REGEX, "").replace("#", "")
        this.setState({editColorCode: colorCode})
        this.refreshUi()
    }

    handleProjectNameChange(val) {
        if (this.limitExceededAlert(val.length, prosConnect.PROJECT_NAME_MAX_LEN, "Liian pitkä nimi")) {
            return
        }
        this.setState({
            projectName: prosConnect.filterSpecialChars(val),
            hasContentChanged: true
        })
    }

    handleProjectDescriptionChange(val) {
        this.setState({
            projectDescription: prosConnect.filterSpecialChars(val),
            hasContentChanged: true
        })
    }

    renderChTagRemoval(chTag, i) {
        // first on/off is urgent and can not be removed
        if (i === 0) {
            return null
        }
        return <div key={chTag.stag}>
            <BasicButton
                icon={"times"}
                action={()=>{
                    this.openDeletePopup("chTag", i)
                }}
                btnType={"prompt"}
            />
        </div>
    }

    renderIconSelectButton(chTag, i) {
        // first on/off is urgent and can not be removed
        if (i === 0) {
            return <i
                className="ui-icon ui-icon-semantic-urgent ui-icon_color-no"
                title={"Kiireellinen"}
            />
        }
        if ( ! prosConnect.isSuperUserModeInUse()) {
            return null
        }
        return <i
            className={"btn btn-type-prompt ui-icon "
                + (!isValueEmpty(chTag['icon']) ? "btn-3rd ui-icon_set-user ui-icon-" + userIconData[chTag['icon']] : " ui-icon-plus")}
            onClick={() => BasicModal('Valitse ikoni', <IconPicker currentIcon={chTag?.icon}/>, {
                cancelCallback: () => {
                    selectedUserIcon = null
                },
                action: () => {
                    chTag['icon'] = selectedUserIcon
                    selectedUserIcon = null
                    this.refreshUi()
                }
            })}
        />
    }

    renderOnOffSelections() {
        return this.onOffTags.tags.map((chTag, i) => {
            if (!chTag.removed) {
                return <div key={"onoffs__" + i}
                            className={"grid-container grid-flex-5" + (!chTag.inUse ? " disable-children" : "")}>
                    <div>{this.onOffCheckboxes(chTag)}</div>
                    <div>
                        <TextInput
                            value={chTag.label}
                            isControlled={true}
                            onChange={val => this.handleChangeChLabel(val, i)}
                        />
                    </div>
                    <div>{this.renderRestrictedOnOff(chTag)}</div>
                    <div>{this.renderIconSelectButton(chTag, i)}</div>
                    <div>{this.renderChTagRemoval(chTag, i)}</div>
                </div>
            }
            return null
        })
    }

    renderFreeText() {
        return this.freeTexts.tags.map((txt, i) => {
            if (!txt.removed) {
                return <div key={"free__text" + i} className={"grid-container grid-flex-6" + (!txt.inUse ? " disable-children" : "")}>
                        <div>{this.renderInUseFreeText(txt)}</div>
                        <div>
                            <TextInput
                                value={txt.label}
                                isControlled={true}
                                onChange={val => this.handleFreeTextChange(val, txt)}
                            />
                        </div>
                        <div>{this.renderRestrictedFreeText(txt)}</div>
                        <div>{this.renderMandatoryFreeText(txt)}</div>
                        <div className={"custom-child-absolute"}>{this.renderEnumMenu(txt)}</div>
                        <div>
                            <BasicButton
                                icon={"times"}
                                action={()=>{
                                    this.openDeletePopup("freeText", i)
                                }}
                                btnType={"prompt"}
                            />
                        </div>
                    </div>
            }
            return null
        })
    }

    isStateTag(mvTag) {
        return prosConnect.getActiveProject().isStateSTag(mvTag.stag)
    }

    renderOptionIcon(mvTag, option, ind) {
        if (!this.isStateTag(mvTag)) {
            return null
        }
        let iconClass = getIconClass(ind);
        if (!iconClass) {
            return null
        }
        return <i className={"ui-icon ui-icon-md " + iconClass}/>
    }

    renderDefaultOptionSwitch(mvTag, optionInd) {
        if (!this.isStateTag(mvTag)) {
            return null
        }
        let defaultStateAttrName = prosConnect.getActiveProject().stateDefaultAttrName()
        let isSelected = this.state[defaultStateAttrName] === optionInd.toString()

        return (
            <Checkbox
                checked={isSelected}
                disabled={!this.isAuthorized()}
                onChange={() => {
                    let change = {}
                    change[defaultStateAttrName] = isSelected ? STR_NO_VALUE : optionInd.toString()
                    change['hasContentChanged'] = true
                    this.setState(change)
                }}
            />
        )
    }

    renderLateSelection(mvTag, option) {
        if (!this.isStateTag(mvTag)) {
            return null
        }

        return (
            <Checkbox
                checked={option.isLate}
                disabled={!this.isAuthorized()}
                onChange={() => {
                    option.isLate = !option.isLate
                    this.refreshUi()
                }}
            />
        )
    }

    getCssColorCode(colorCode) {
        return isValidColorCode(colorCode) ? "#" + colorCode : null
    }

    renderItemPanelHeader(mvTag) {
        function renderStateColumn(isStateTag) {
            return isStateTag ?
                <>
                    <div><p title={"Valitse tila joka aiheuttaako myöhästymis- ja kiireellisyysmerkinnän"}
                        className={"text-sm"}>Kesken</p></div>
                    <div><p title={"Oletus tila uudelle kirjaukselle"} className={"text-sm"}>Oletus</p></div>
                </>
                :
                <>
                    <div/>
                    <div/>
                </>
        }
        return <div className={"grid-container grid-flex-7"}>
                <div><p className={"text-sm"}>{this.state.isReorderingOptions ? "Järjestele" : "Käytössä"}</p></div>
                <div><p className={"text-sm"}>Nimi</p></div>
                <div className={"custom-child-absolute"}><p className={"text-sm"}>Muokkaus raj. oikeudet</p></div>
                {renderStateColumn(this.isStateTag(mvTag))}
                <div><p title={"Valitse valinnan taustaväri taulukkonäkymässä"} className={"text-sm"}>Taustaväri</p></div>
                <div/>
            </div>
    }

    renderOptionRestricted(mvTag, option) {
        if (!featureEnabled(FEAT_SET_RESTRICTED_ACCESS)) {
            return null
        }

        return (
            <Checkbox
                checked={mvTag.limitedEdit ? option.limitedEdit : false}
                disabled={!mvTag.limitedEdit}
                onChange={() => {
                    option.limitedEdit = !option.limitedEdit
                    this.refreshUi()
                }}
            />
        )
    }

    onDragStart(ev, mvTag, option) {
        this.draggingTag = mvTag
        this.draggingOption = option
        ev.dataTransfer.setData('text', '');
    }

    onDragOver(ev) {
        ev.preventDefault()
    }

    onDrop(ev, mvTag, afterOption) {
        ev.stopPropagation()
        let newOrder = 0
        let options = []
        function addToNewOptions(option) {
            option.uiOrder = newOrder
            options.push(option)
            newOrder += 1
        }
        if (this.draggingTag.stag === mvTag.stag && this.draggingOption !== afterOption) {
            let fromOptions = JSON.parse(JSON.stringify(mvTag.options))
            fromOptions.forEach(option => {
                if (option.optionIndex === this.draggingOption.optionIndex) {
                    // skip as moving this to new position
                }
                else if (option.optionIndex === afterOption.optionIndex) {
                    addToNewOptions(option)
                    addToNewOptions(this.draggingOption)
                } else {
                    addToNewOptions(option)
                }
            })
            mvTag.options = options
            this.refreshUi()
        }
        this.draggingTag = undefined
        this.draggingOption = undefined
    }

    renderEnabledSwitch(option, isStateTag){
        if(this.state.isReorderingOptions){
            return <i className={"ui-icon ui-icon-drag-v"}/>
        }
        return <ToggleSwitch
            checked={option.inUse}
            disabled={!this.isAuthorized()}
            onChange={() => {
                if (!isStateTag || option.optionIndex !== 0) {
                    option.inUse = !option.inUse
                    this.refreshUi()
                } else {
                    prosNotificationShow(this, "Ensimmäistä tilaa ei voi estää")
                }
            }}
        />
    }

    renderMultiSelectOptions(mvTag) {
        let self = this
        const isStateTag = this.isStateTag(mvTag)
        function renderDeleteButton(option, i, mvTag, isStateTag) {
            // Find last non-removed option
            let lastOptionInd = mvTag.options.length-1;
            while (lastOptionInd > 0 && mvTag.options[lastOptionInd].removed) {
                lastOptionInd--
            }
            if (isStateTag && lastOptionInd < 4) {
                // show delete button for optional states which is > info
                return <div className={"not-visible"}><button className={"btn btn-icon"}><span/></button></div>
            }
            if (i !== lastOptionInd) {
                // show delete button only for last option
                return <div className={"not-visible"}><button className={"btn btn-icon"}><span/></button></div>
            }
            return <BasicButton
                icon={"times"}
                action={()=>{
                    self.openDeletePopup("multiChoice", option, self)
                }}
                btnType={"prompt"}
            />
        }

        return mvTag.options
            .map(option => {
            if (!option.removed) {
                return <div key={"multichildren" + option.optionIndex}
                        draggable={this.state.isReorderingOptions}
                        onDragStart={(e) => this.onDragStart(e, mvTag, option)}
                        onDragOver={(e) => this.onDragOver(e)}
                        onDrop={(e) => { this.onDrop(e, mvTag, option) }}
                        className={"grid-container grid-flex-7" + (!option.inUse ? " disable-children" : "")}>
                    <div>
                        {this.renderEnabledSwitch(option, isStateTag)}
                    </div>
                    <div>
                        <span className={"label-set" + (isStateTag ? " input-icon-set" : "")
                            + (!this.isAuthorized() ? " label-set-disabled" : "" )
                        }>
                            {this.renderOptionIcon(mvTag, option, option.optionIndex)}
                            <input
                                type={"text"}
                                value={option.label}
                                onChange={ev => this.handleMultiValueOptionNameChange(ev, option)}
                                disabled={!this.isAuthorized()}
                            />
                        </span>
                    </div>
                    <div>{this.renderOptionRestricted(mvTag, option)}</div>
                    <div>{this.renderLateSelection(mvTag, option)}</div>
                    <div>{this.renderDefaultOptionSwitch(mvTag, option.optionIndex)}</div>
                    <div>
                        <BasicButton
                            icon={"brush"}
                            btnClass={"2nd"}
                            action={() => this.openColorPicker(option)}
                            className={isValidColorCode(option.color) ? "btn-has-color-tag" : null}
                            btnType={"prompt"}
                        >
                            {isValidColorCode(option.color) ?
                                <i className={"btn-tag btn-tag-color"}
                                   style={{backgroundColor: this.getCssColorCode(option.color)}}
                                />
                                : null}
                        </BasicButton>
                    </div>
                    <div>{renderDeleteButton(option, option.optionIndex, mvTag, isStateTag)}</div>
                </div>
            }
            return null
        })
    }

    openColorPicker(option) {
        const baseColorSet1 = [
            '#00d26d',//color-ok-80:
            '#1eff93',//color-ok-60
            '#69ffb7',//color-ok-40
            '#b4ffdb',//color-ok-20
            '#daffed',//color-ok-10
            //'#ecfff6'//color-ok-5
        ]
        const baseColorSet2 = [
            '#ffb530',//color-maybe-80
            '#ffc764',//color-maybe-60
            '#ffda97',//color-maybe-40
            '#ffeccb',//color-maybe-20
            '#fff6e5',//color-maybe-10
            //'#fffaf2',//color-maybe-5
        ]
        const baseColorSet3 = [
            '#ff1d1d',//color-no-80
            '#ff5656',// --color-no-60:
            '#ff8e8e',// --color-no-40:
            '#ffc7c7',// --color-no-20:
            '#ffe3e3',// --color-no-10:
            //'#fff1f1',// --color-no-5:
        ]
        const baseColorSet4 = [
            '#1c84ff',//color-main-80
            '#55a3ff',//color-main-60
            '#8dc2ff',//color-main-40
            '#c6e0ff',//color-main-20
            '#e3f0ff'//color-main-10
        ]

        const openColorPopup =(option)=>{
            prosPopupOpenDynamic(this,
                'Valitse valinnan taustaväri taulukkonäkymässä',
                ()=> <>
                    <section className={"flex-center valign-center"}>
                        <TextInput
                            placeholder={"6 tai 8 num. värikoodi, esim. 0066FF"}
                            value={this.state.editColorCode ?? ""}
                            onChange={val => {
                                this.handleMultiValueColorChange(val)
                            }}
                            className={"width-60_xl"}
                            info={"Anna värin HEX-koodi ilman #-merkkiä"}
                            isControlled={true}
                        />
                        <div className={"grid-container grid-1 grid-2_lg"}>
                            <div className={"margin-right"}>
                                <h4>Perusvärit</h4>
                                <div className={"btn-set display-flex margin-bottom"}>{this.renderColorSet(baseColorSet1)}</div>
                                <div className={"btn-set display-flex margin-bottom"}>{this.renderColorSet(baseColorSet2)}</div>
                                <div className={"btn-set display-flex margin-bottom"}>{this.renderColorSet(baseColorSet3)}</div>
                                <div className={"btn-set display-flex margin-bottom"}>{this.renderColorSet(baseColorSet4)}</div>
                            </div>
                            <div className={"margin-left"}>
                                <h4>Väripaletit</h4>
                                {this.renderColorSets(option)}
                            </div>
                            <div>
                                <h4>Kirkkaat</h4>
                                <div className={"btn-set display-flex"}>{this.renderColorSet(MULTI_COLOR_SET_HILITE)}</div>
                            </div>
                            <div>
                                <h4>Harmaat</h4>
                                <div className={"btn-set display-flex"}>{this.renderColorSet(MULTI_COLOR_SET_GRAY)}</div>
                            </div>
                        </div>
                    </section>
                    <footer>
                        <div className={"btn-set"}>
                            <ConfirmButton
                                label={"Valmis"}
                                action={()=> {
                                    if (this.changeColor(this.state.editColorCode)) {
                                        this.closeColorPicker()
                                    }
                                }}
                            />
                        </div>
                    </footer>
                </>,
                ()=> this.closeColorPicker(),
            )
        }
        let plainCode = option.color.replace("#", "")
        this.setState({
            openColorPicker: option,
            editColorCode: plainCode,
        }, ()=> openColorPopup(option))
    }

    closeColorPicker() {
        this.setState({
            openColorPicker: undefined
        })
        prosPopupClose()
    }

    changeColor(color) {
        let plainCode = color.replace("#", "")
        if (plainCode === "" || isValidColorCode(plainCode)) {
            // Overwrite selected MV option bg color - this makes a mutable write directly into MV settings
            let editingOption = this.state.openColorPicker
            editingOption.color = color
            this.setState({
                openColorPicker: editingOption,
                editColorCode: plainCode,   // To show selected hex value in text input box
                hasContentChanged: true     // Config changed - show "save" button
            })
            return true
        }
        prosAppNotif("Virheellinen värikoodi")
        return false
    }

    renderColorSet(set){
        let btnSet = []
        set.forEach(color => {
            let isSelectedColor = color === "#" + this.state.editColorCode
            btnSet.push(<BasicButton
                key={color}
                action={()=>{
                    this.changeColor(color)
                }}
                icon={isSelectedColor ? "check" : null}
                selected={isSelectedColor}
                style={{backgroundColor: color}}
            />)
        })
        return btnSet
    }

    renderColorSets(){
        return Object.keys(MULTI_COLOR_SETS).map((set, i) => {
            return <div key={i} className={"btn-set display-flex margin-bottom"}>
                {this.renderColorSet(MULTI_COLOR_SETS[set])}
            </div>
        })
    }

    makeNewMultivalueOption(newIndex) {
        return {
            label: "Uusi",
            inUse: true,
            opt2: false,
            color: STR_NO_VALUE,
            limitedEdit: false,
            isLate: false,
            uiOrder: newIndex,
            optionIndex: newIndex,
            removed: false
        }
    }

    handleAddNewMultiSelectOption(mvTag) {
        if (this.limitExceededAlert(mvTag.options.length+1, MAX_RB_OPTIONS,
            "Vaihtoehtojen lukumäärä on rajoitettu")) {
            return;
        }
        mvTag.options.push(this.makeNewMultivalueOption(mvTag.options.length));
        this.refreshUi();
    }

    renderMultiValueInUse(mvTag) {
        return <ToggleSwitch
            checked={mvTag.inUse}
            disabled={!this.isAuthorized()}
            onChange={()=> {
                mvTag.inUse = !mvTag.inUse;
                mvTag.options.forEach(option => { option.inUse = mvTag.inUse });
                this.refreshUi();
            }}
        />
    }

    renderMultiValueRestricted(mvTag) {
        if (!featureEnabled(FEAT_SET_RESTRICTED_ACCESS)) {
            return null
        }
        return <Checkbox
                checked={mvTag.limitedEdit}
                disabled={!this.isAuthorized()}
                text="Muokkaus raj. oikeudet"
                onChange={() => {
                    mvTag.limitedEdit = !mvTag.limitedEdit
                    this.refreshUi()
                }}
            />
    }

    renderMultiValueMandatory(mvTag) {
        if (!featureEnabled(FEAT_SET_MANDATORY)) {
            return null
        }

        // state is mandatory - disable changing
        const disabled = (!this.isAuthorized() || this.isStateTag(mvTag))

        return (
            <Checkbox
                checked={this.isStateTag(mvTag) ? true : mvTag.isMandatory}
                disabled={disabled}
                text="Pakollinen"
                onChange={() => {
                    mvTag.isMandatory = !mvTag.isMandatory;
                    this.refreshUi();
                }}
            />
        )
    }

    removeMultiValueTag(i) {
        prosPopupClose()
        this.multiValueTags.tags[i].removed = true
        this.notifyRemoval();
        this.refreshUi();
    }

    renderMultiSelectRemoval(mvTag, i) {
        // first is state and can not be removed
        if (i === 0) {
            return null
        }
        return <BasicButton
            key={mvTag.stag}
            icon={"times"}
            action={()=>{
                this.openDeletePopup("multiValue", i)
            }}
            btnType={"prompt"}
        />
    }

    detectSpacePress(e) {
        if(e.keyCode === 32) {
            e.stopPropagation();
        }
    }

    renderAddNewOption(mvTag) {
        if (mvTag.options.length >= featureLimit(FEAT_MAX_MV_OPTIONS, MAX_RB_OPTIONS)) {
            return (
                <div className={"msg msg-notice"}>
                    <p>{MAX_COUNT_LIMITED_BY_LICENSE}</p>
                </div>
                )
        }
        return (
            <div className={"btn-set"}>
                <BasicButton
                    btnClass={"2nd"}
                    label={"Lisää uusi vaihtoehto"}
                    action={() => {this.handleAddNewMultiSelectOption(mvTag)}}
                    icon={"plus"}
                    disabled={!this.isAuthorized()}
                />
            </div>
        )
    }

    renderMultiSelects() {
        return this.multiValueTags.tags.map((mvTag, i) => {
            if (mvTag && !mvTag.removed) {
                const headerElement = <div key={"multiheader__" + i}
                        className={"grid-container grid-flex-5_lg custom-accordion-title" + (!mvTag.inUse ? " disable-children" : "")}
                    >
                        <div>{this.renderMultiValueInUse(mvTag)}</div>
                        <TextInput
                            value={mvTag.label}
                            isControlled={true}
                            onChange={val => this.handleMultiValueNameChange(val, mvTag)}
                            onKeyDown={this.detectSpacePress}
                            placeholder={"Kirjoita valinnan nimi"}
                        />
                        <div className={"custom-child-absolute"}>{this.renderMultiValueRestricted(mvTag)}</div>
                        <div>{this.renderMultiValueMandatory(mvTag)}</div>
                        <div>{this.renderMultiSelectRemoval(mvTag, i)}</div>
                    </div>
                return <AccordionDropdown key={'accordion__' + mvTag.stag + '__' + i}
                            header={headerElement}
                            dynamicOpen={this.state.isReorderingOptions}
                            closeable={!this.state.isReorderingOptions}
                        >
                            {this.renderItemPanelHeader(mvTag)}
                            {this.renderMultiSelectOptions(mvTag)}
                            {this.renderAddNewOption(mvTag)}
                    </AccordionDropdown>
            }
            return null
        })
    }

    handleAddNewMultiSelect() {
        if (!this.isAuthorized()) {
            return
        }
        let nextMaxTagInd = this.multiValueTags.maxInd + 1
        if (this.limitExceededAlert(nextMaxTagInd, prosConnect.MAX_RB_TAGS, "Valintojen lukumäärä on rajoitettu")) {
            return
        }
        this.multiValueTags.maxInd = nextMaxTagInd;
        this.multiValueTags.tags.push({
            stag: ATTR_STAG + nextMaxTagInd,
            label: "Uusi",
            inUse: true,
            isMandatory: false,
            limitedEdit: false,
            removed: false,
            options: [this.makeNewMultivalueOption()]
            })
        this.refreshUi()
    }

    async deleteActiveProject() {
        await deleteProject();
        this.goBack(true)
    }

    async saveChanges() {
        function boolToStr(boolVal) {
            return boolVal ? STR_YES : STR_NO
        }
        function getSavedColorCode(code) {
            if (typeof code !== "string") {
                return STR_NO
            }
            let colorCode = code.replace("#", "")
            return isValidColorCode(colorCode) ? colorCode : STR_NO
        }

        if (!this.isAuthorized()) {
            prosNotificationShow(this,"Ei käyttöoikeutta")
            return;
        }
        this.setState({ isLoading: true })
        let newAttrs = prosConnect.getActiveProject().attrs

        if (this.myProdectCollege) {
            // console.log("myProdectCollege:", this.myProdectCollege.email, "email:", this.state.myProdectCollegeEmail)
            if (this.myProdectCollege.email === this.state.myProdectCollegeEmail) {
                // college not changed
            } else if (this.myProdectCollege.email === '') {
                // add college
                this.myProdectCollege.email = this.state.myProdectCollegeEmail
                this.myProdectCollege.text = makeNameFromEmail(this.state.myProdectCollegeEmail)
                await prosConnect.getActiveProject()
                    .awaitAddObject(this.myProdectCollege, prosConnect.getActiveProject().usersListId)
            } else if (this.state.myProdectCollegeEmail === '') {
                // remove college
                await prosConnect.getActiveProject().awaitRemoveItem(this.myProdectCollege)
            } else {
                // change college
                this.myProdectCollege.email = this.state.myProdectCollegeEmail
                this.myProdectCollege.text = makeNameFromEmail(this.state.myProdectCollegeEmail)
                await prosConnect.getActiveProject().awaitUpdateItem(this.myProdectCollege, false)
            }
        }

        if (prosConnect.isSuperUserModePossible() && this.state.mainProjectName) {
            newAttrs[ATTR_IS_TEMPLATE] = boolToStr(this.state.isTemplate)
        }
        newAttrs[ATTR_TEXT] = this.state.projectName
        newAttrs[ATTR_PRJ_DESC] = this.state.projectDescription
        newAttrs[ATTR_DELAY_TO_UPDATE_IDENTIFIERS] = this.state.delayToUpdatedIdentifiersMs
        newAttrs[ATTR_SHOW_IDENTIFIERS] = boolToStr(this.state.showIdentifiers)
        newAttrs[ATTR_EXPORT_WEB_REPORT_ACT] = boolToStr(this.state[ATTR_EXPORT_WEB_REPORT_ACT])
        newAttrs[ATTR_EXPORT_WEB_REPORT] = boolToStr(this.state[ATTR_EXPORT_WEB_REPORT])
        newAttrs[ATTR_EXPORT_JSON] = boolToStr(this.state[ATTR_EXPORT_JSON])
        newAttrs[ATTR_IS_PICTURES_ALLOWED] = boolToStr(this.state[ATTR_IS_PICTURES_ALLOWED])
        newAttrs[ATTR_IS_REPORTS_ALLOWED] = boolToStr(this.state[ATTR_IS_REPORTS_ALLOWED])
        newAttrs[ATTR_EXPIRATION_REQUIRED] = boolToStr(this.state.dueDateMandatory)
        newAttrs[ATTR_EXPIRATION_RESTRIC_OWN] = boolToStr(this.state.dueDateRestrictedOwn)
        newAttrs[ATTR_EXPIRATION_RESTRIC_SET] = boolToStr(this.state.dueDateRestricted)
        newAttrs[ATTR_DATE_AND_TIME] = boolToStr(this.state.dueDateTime)
        newAttrs[ATTR_PROJECT_START] = this.state.projectStart
        newAttrs[ATTR_PROJECT_END] = this.state.projectEnd

        let defaultStateAttrName = prosConnect.getActiveProject().stateDefaultAttrName()
        newAttrs[defaultStateAttrName] = this.state[defaultStateAttrName]

        this.onOffTags.tags.forEach( chTag => {
            if (chTag.removed) {
                newAttrs[chTag.stag] = STR_NO_VALUE;
            } else {
                newAttrs[chTag.stag] = chTag.label + ";" +
                    boolToStr(chTag.inUse) + ";" +
                    boolToStr(chTag.opt2) + ";" +
                    boolToStr(chTag.limitedEdit)
            }
        })
        this.freeTexts.tags.forEach(txt => {
            if (txt.removed) {
                newAttrs[txt.stag] = STR_NO_VALUE;
            } else {
                newAttrs[txt.stag] = txt.label + ";" +
                    boolToStr(txt.inUse) + ";" +
                    boolToStr(txt.isMandatory) + ";" +
                    boolToStr(txt.limitedEdit) + ";" +
                    txt.textType
            }
        })
        let labelMissing = false
        this.multiValueTags.tags.forEach(mvTag => {
            if (mvTag.removed) {
                newAttrs[mvTag.stag] = STR_NO_VALUE
            } else {
                if (mvTag.label === '') {
                    labelMissing = true
                }
                let str = mvTag.label + ";" +
                    boolToStr(mvTag.inUse) + ";" +
                    boolToStr(mvTag.isMandatory) + ";" +
                    mvTag.color + ";" +
                    boolToStr(mvTag.limitedEdit);
                mvTag.options
                    .sort((a,b) => a.optionIndex-b.optionIndex)
                    .forEach( option => {
                        if (!option.removed) {
                            if (option.label === '') {
                                labelMissing = true
                            }
                            str += ";;" + option.label + ";" +
                                boolToStr(option.inUse) + ";" +
                                boolToStr(option.isMandatory) + ";" +
                                getSavedColorCode(option.color) + ";" +
                                boolToStr(option.limitedEdit) + ";" +
                                boolToStr(option.isLate) + ";" +
                                option.uiOrder
                    }
                })
                newAttrs[mvTag.stag] = str
            }
        });
        if (labelMissing) {
            prosNotificationShow(this, "Virhe: monivalinnan nimi puuttuu");
            this.setState({ isLoading: false })
            return;
        }

        // Save logo file name to project object
        newAttrs[ATTR_LOGO_FILE_NAME] = this.state.logoFileName ? this.state.logoFileName: STR_NO_VALUE

        prosLog("Saving sub-project settings", this.state.projectId, this.state.projectName);
        let pid = prosConnect.getActiveProjectID()
        await this.sendDataToServer(newAttrs);
        // Deactivate and to load project again to refresh all settings
        prosConnect.deactivateActiveProject()
        this.props.reloadProject(pid)
        await this.setUiFromProjectSettings()
    }

    async sendDataToServer(item) {
        await prosConnect.getActiveProject().awaitUpdateItem(item, true);
        this.setState({
            loading: false
        });
    }

    handleCollegeEmailChange(event) {
        event.preventDefault();
        if (this.limitExceededAlert(event.target.value.length, prosConnect.MAIN_PROJ_NAME_MAX_LEN, "Liian pitkä nimi")) {
            return
        }
        this.setState({
            mainProjectName: prosConnect.filterSpecialChars(event.target.value),
            hasContentChanged: true
        })
    }

    handleMainProjectNameChange(event) {
        event.preventDefault();
        if (this.limitExceededAlert(event.target.value.length, prosConnect.MAIN_PROJ_NAME_MAX_LEN, "Liian pitkä nimi")) {
            return
        }
        this.setState({
            mainProjectName: prosConnect.filterSpecialChars(event.target.value),
            hasContentChanged: true
        })
    }

    renderDumpButton() {
        if (!prosConnect.isSuperUserModePossible()) {
            return null
        }
        return <BasicButton
            btnClass={""}
            label={"Test-dump"}
            action={() => {prosConnect.dumpProsObj(prosConnect.getActiveProject().attrs)}}
        />
    }

    renderSaveCancelButtons(){
        if(!this.state.hasContentChanged || !this.isProjectNameValid()) return null
        return(
            <footer className={"page-footer"}>
                <div className={"btn-set_center"}>
                    <CancelButton
                        action={()=> {
                            this.props.reloadProject(prosConnect.getActiveProject().getPid())
                            this.setUiFromProjectSettings()
                        }}
                    />
                    <ConfirmButton
                        action={()=> this.saveChanges()}
                        disabled={this.state.loading || !this.isAuthorized()}
                    />
                </div>
            </footer>
        )
    }

    renderTemplateInput() {
        let project = prosConnect.getActiveProject()
        if (!project) return null
        if (prosConnect.isSuperUserModePossible()) {
            return <div className="sub-container">
                <ToggleSwitch
                    label={"Malliosaprojekti"}
                    checked={this.state.isTemplate}
                    disabled={!this.isAuthorized()}
                    onChange={()=> {
                        this.setState({
                            isTemplate: !this.state.isTemplate,
                            hasContentChanged: true
                        })
                    }}
                />
                <Spacer />
                {this.state.isTemplate ? <p>Malliosaprojektit näkyvät listauksessa kun luodaan uutta osaprojektia mallin mukaan.</p> : null}
            </div>
        } else if (this.state.isTemplate ) {
            return (<div className="sub-container">
                <h1> Osaprojekti on merkitty malliosaprojektiksi </h1>
            </div>)
        }
        return null
    }

    settingsNavigation(isActive) {
        return <>
            <li>
                <BasicButton
                    label={"Yleiset"}
                    icon={"gear"}
                    action={()=>{
                        this.setActivePage('settings')
                        setHelpContext('projectSettings')
                    }}
                    hilite={this.state.activeSettingsPage === 'settings'}
                    selected={this.state.activeSettingsPage === 'settings'}
                    shrink={"md"}
                />
            </li>
            <li className={"dom-hide dom-show-block_md"}>
                <BasicButton
                    label={"Kirjausten asetukset"}
                    icon={"sliders"}
                    action={()=> this.openObsSettings()}
                    hilite={this.state.activeSettingsPage === 'obs-settings'}
                    selected={this.state.activeSettingsPage === 'obs-settings'}
                    shrink={"md"}
                />
            </li>
            <li>
                <BasicButton
                    label={"Sijaintikuvat"}
                    icon={"image-tack"}
                    action={()=>{
                        this.setActivePage('loctPicts')
                    }}
                    hilite={this.state.activeSettingsPage === 'loctPicts'}
                    selected={this.state.activeSettingsPage === 'loctPicts'}
                    shrink={"md"}
                />
            </li>
            {this.renderUserAdminLink()}
            {isActive ? <li>
                <BasicButton
                    label={"Tietojen palautus"}
                    icon={"bin-undo"}
                    action={()=>{
                        this.setActivePage('projectDeletedData')
                    }}
                    hilite={this.state.activeSettingsPage === 'projectDeletedData'}
                    selected={this.state.activeSettingsPage === 'projectDeletedData'}
                    shrink={"md"}
                />
            </li> : null}
        </>
    }

    renderUserAdminLink() {
        if (this.state.myProdectCollegeEmail !== undefined) {
            return <>
                    <Spacer line={true}/>
                    <li className={"padding"}>
                        <TextInput
                            label={"Kumppani"}
                            placeholder={"Kirjoita email-osoite"}
                            value={this.state.myProdectCollegeEmail}
                            isControlled={true}
                            onChange={val => this.setState({
                                myProdectCollegeEmail: prosConnect.filterSpecialChars(val),
                                hasContentChanged: true
                            })}
                        />
                    </li>
                </>
        }
        // Normal admin
        if (prosConnect.hasPermissionTo('editAdmin', undefined, undefined, false))
            return <li>
                <BasicButton
                    label={"Käyttöoikeudet"}
                    icon={"user"}
                    action={()=>{
                        this.setActivePage('permissionGroups')
                    }}
                    hilite={this.state.activeSettingsPage === 'permissionGroups'}
                    selected={this.state.activeSettingsPage === 'permissionGroups'}
                    shrink={"md"}
                />
            </li>
    }

    renderExcelLinks() {
        if (featureEnabled(FEAT_EXCEL_EXPORT) || featureEnabled(FEAT_EXCEL_IMPORT)) {
            return <li>
                <BasicButton
                    label={"Tuo/Vie Excel"}
                    icon={"excel"}
                    action={()=>{
                        this.setActivePage('excelExport')
                    }}
                    hilite={this.state.activeSettingsPage === 'excelExport'}
                    selected={this.state.activeSettingsPage === 'excelExport'}
                    shrink={"md"}
                />
            </li>
        }
    }

    renderMoveProject(isActive) {
        if(!isActive) return null
        return <li>
            <BasicButton
                label={"Siirrä"}
                icon={"send"}
                action={()=>{
                    this.setActivePage('moveProject')
                }}
                hilite={this.state.activeSettingsPage === 'moveProject'}
                selected={this.state.activeSettingsPage === 'moveProject'}
                shrink={"md"}
            />
        </li>
    }

    setActivePage(page) {
        if (page === this.state.activeSettingsPage) {
            return
        }
        this.setState({activeSettingsPage: page});
        saveConfigStr(prosConnect.SAVED_SETTINGS_SUBVIEW, page)
    }

    doArchivePack(project) {
        prosConnect.awaitStartPackProject(project.getPid())
        prosNotificationShow(this, "Projektin tiedot pakataan. Saat sähköpostissa linkin parin tunnin kuluessa.",
            false, true)
    }

    renderToggleActivePassive(project) {
        if (!prosConnect.hasPermissionTo("editAdmin", undefined, undefined, false)) {
            return
        }
        const isProjectActive = project.isProjectActive()
        let buttonLabel = isProjectActive ? 'Arkistoi': 'Aktivoi'
        return <>
            <li>
                <BasicButton
                    label={buttonLabel}
                    icon={isProjectActive ? 'outline-lock': 'outline-lock-open'}
                    action={()=>{
                        prosPopupOpen(this,
                            buttonLabel + ' osaprojekti?',
                            <>
                                <section>
                                    {isProjectActive ? <p>Arkistoiduista osaprojekteista ei laskuteta.</p>
                                        : <p>Aktivoiduista osaprojekteista saatetaan laskuttaa.</p>}
                                </section>
                                <footer className={"popup-footer"}>
                                    <div className={"btn-set"}>
                                        <CancelButton
                                            action={()=> prosPopupClose()}
                                        />
                                        <ConfirmButton
                                            label={"Jatka"}
                                            action={()=> {
                                                this.doArchiveOrActivateProject()
                                                prosPopupClose()
                                            }}
                                        />
                                    </div>
                                </footer>
                            </>
                        )
                    }}
                    shrink={"md"}
                    btnType={"prompt"}
                    btnClass={!isProjectActive ? "primary" : null}
                    className={!isProjectActive ? "bg-color-2nd" : null}
                />
            </li>
            <li>
                <BasicButton
                    label={"Pakkaa"}
                    icon={"pack"}
                    action={()=>{
                        prosPopupOpen(this,
                            'Pakkaa osaprojekti',
                            <>
                                <section>
                                    <p>Toiminto tekee pakatun tiedoston osaprojektin tiedoista ja<br/> lähettää sen sinulle emaililla liitteenä.</p>
                                </section>
                                <footer className={"popup-footer"}>
                                    <div className={"btn-set"}>
                                        <CancelButton
                                            action={()=> prosPopupClose()}
                                        />
                                        <ConfirmButton
                                            label={"Jatka"}
                                            action={()=> {
                                                this.doArchivePack(project)
                                                prosPopupClose()
                                            }}
                                        />
                                    </div>
                                </footer>
                            </>
                        )
                    }}
                    shrink={"md"}
                    btnType={"prompt"}
                />
            </li>
        </>
    }

    renderDeleteProject() {
        return <li>
            <BasicButton
                label={"Poista"}
                icon={"bin"}
                action={()=>{
                    this.openConfirmDeleteProjectPopup()
                }}
                shrink={"md"}
                btnType={"prompt"}
            />
        </li>
    }

    renderProjectSettingsInfo() {
        let project = prosConnect.getActiveProject()
        if (this.state.mainProjectName.length < 1) {
            return <div className={"project-settings-info"}><p>Projekti puuttuu</p></div>
        }
        const showCustomerGroupId = prosConnect.isSuperUserModePossible() || prosConnect.isSuperUserModeInUse()
        return <div className={"project-settings-info"}>
            <h6>Projekti</h6><p>{this.state.mainProjectName}</p>
            <h6>Asiakas</h6><p>{project.attrs.customer_name}</p>
            {showCustomerGroupId ? <><h6>Asiakastunnus</h6><p>{project.customerGroup}</p></> : null}
            {!project.isProjectActive() ?
                <StyledProjectInfo
                    prosObj={prosConnect.getActiveProject().attrs}
                    prosId={this.state.projectId}
                    info={"archived"}
                /> : null}
            {project.getAttr(prosConnect.ATTR_LAST_ARCHIVED_MS) !== STR_NO_VALUE ?
                    <><h6>Pakattu</h6><p>{formatDate(project.getAttr(prosConnect.ATTR_LAST_ARCHIVED_MS))}</p></> : null}
            <StyledProjectInfo
                prosObj={prosConnect.getActiveProject().attrs}
                prosId={this.state.projectId}
                info={"created"}
            />
            <StyledProjectInfo
                prosObj={prosConnect.getActiveProject().attrs}
                prosId={this.state.projectId}
                info={"updated"}
            />
            <StyledProjectInfo
                prosObj={prosConnect.getActiveProject().attrs}
                prosId={this.state.projectId}
                info={"id"}
                showId={prosConnect.userHasDebugMenu()}
            />
        </div>
    }

    goBack(refreshProjectList) {
        prosConnect.deleteConfigStr(prosConnect.SAVED_SETTINGS_SUBVIEW)
        this.props.closeView(refreshProjectList ? 2000 : undefined)
    }

    renderTitleWithRestrictedAccess() {
        if (!featureEnabled(FEAT_SET_RESTRICTED_ACCESS)) {
            return null
        }
        return (
            <p title={"Valitse voiko valintaa muokata rajoitetuilla käyttöoikeuksilla"}
               className={"text-sm"}
            >
                Muokkaus raj. oikeudet
            </p>
        )
    }

    renderTitleMandatory() {
        if (!featureEnabled(FEAT_SET_MANDATORY)) {
            return null
        }
        return <p title={"Valitse aiheuttaako valinnan puuttuminen huomiomerkinnän kirjauksessa"}
               className={"text-sm"}
            >Pakollinen</p>
    }

    isMaxCountExceeded(tagItems, feature, swMax) {
        let count = tagItems.filter(tag => !tag.removed).length
        return count >= featureLimit(feature, swMax)
    }

    renderAddNewOnOff() {
        if (this.isMaxCountExceeded(this.onOffTags.tags, FEAT_MAX_ON_OFF, MAX_CH_TAGS)) {
            return (
                <div className={"msg msg-notice"}>
                    <p>{MAX_COUNT_LIMITED_BY_LICENSE}</p>
                </div>
            )
        }
        return <div className={"btn-set"}>
                <BasicButton
                    btnClass={"2nd"}
                    label={"Lisää uusi valinta"}
                    icon={"plus"}
                    action={() => {this.handleAddOnOff()}}
                    disabled={!this.isAuthorized()}
                />
            </div>
    }

    renderAddNewText() {
        if (this.isMaxCountExceeded(this.freeTexts.tags, FEAT_MAX_TEXT_FIELDS, prosConnect.MAX_STXT_TAGS)) {
            return (
                <div className={"msg msg-notice"}>
                    <p>{MAX_COUNT_LIMITED_BY_LICENSE}</p>
                </div>
            )
        }
        return <div className={"btn-set"}>
                <BasicButton
                    btnClass={"2nd"}
                    label={"Lisää uusi tekstikenttä"}
                    action={() => {this.handleAddFreeText()}}
                    icon={"plus"}
                    disabled={!this.isAuthorized()}
                />
            </div>
    }

    renderAddNewMultiselect() {
        if (this.isMaxCountExceeded(this.multiValueTags.tags, FEAT_MAX_MV, prosConnect.MAX_RB_TAGS)) {
            return (
                <div className={"msg msg-notice"}>
                    <p>{MAX_COUNT_LIMITED_BY_LICENSE}</p>
                </div>
            )
        }
        return <div className={"btn-set"}>
                <BasicButton
                    btnClass={"2nd"}
                    label={"Lisää uusi monivalinta"}
                    icon={"plus"}
                    action={() => {this.handleAddNewMultiSelect()}}
                    disabled={!this.isAuthorized()}
                />
            </div>
    }

    isProjectNameValid(){
        return prosConnect.PROJECT_NAME_MIN_LEN <= this.state.projectName.length
            && this.state.projectName.length < prosConnect.PROJECT_NAME_MAX_LEN
    }

    renderProjectSettings() {
        return <>
            <h1>Yleiset asetukset</h1>
            <section>
                <div className="slab grid-container grid-1 grid-2_xl">
                    <div>
                        <h2>Osaprojektin nimi</h2>
                        <TextInput
                            value={this.state.projectName}
                            isControlled={true}
                            placeholder={"Kirjoita osaprojektin nimi"}
                            disabled={!this.isAuthorized()}
                            onChange={val => this.handleProjectNameChange(val)}
                            required
                            isValid={this.isProjectNameValid()}
                            info={this.state.projectName.length < prosConnect.PROJECT_NAME_MIN_LEN
                                && !this.isProjectNameValid() && "Osaprojektin nimen pituus vähintään " + prosConnect.PROJECT_NAME_MIN_LEN + " merkkiä"}
                        />
                        <TextInput
                            value={this.state.projectDescription}
                            isControlled={true}
                            placeholder={"Kirjoita osaprojektin kuvaus"}
                            disabled={!this.isAuthorized()}
                            onChange={val => this.handleProjectDescriptionChange(val)}
                            multiline={3}
                        />
                        {this.renderTemplateInput()}
                    </div>
                    <div>
                        <h2>Logo</h2>
                        {this.renderProjectLogo()}
                    </div>
                </div>
                <Spacer line/>
                <div className="slab grid-container grid-1 grid-2_xl">
                    <div>
                        <h2>Osaprojektin kesto</h2>
                        <div className={"element-set width-100 flex-wrap"}>
                            <DatePicker
                                label={'Alkamispäivä'}
                                value={isValueEmpty(this.state.projectStart) ? '' : millisecToDatePicker(this.state.projectStart)}
                                onChange={evt =>{
                                    const start = !isValueEmpty(evt.target.value) ? datePickerReturnValueToMillisec(evt.target.value) : ''
                                    this.setState({
                                        hasContentChanged: true,
                                        projectStart: start
                                    })
                                }}
                                maxDate={millisecToDatePicker(this.state.projectEnd)}
                            />
                            <DatePicker
                                label={'Päättymispäivä'}
                                value={isValueEmpty(this.state.projectEnd) ? '' : millisecToDatePicker(this.state.projectEnd)}
                                onChange={evt =>{
                                    const end = !isValueEmpty(evt.target.value) ? getEndOfWorkingDayTimeMs(datePickerReturnValueToMillisec(evt.target.value)) : ''
                                    this.setState({
                                        hasContentChanged: true,
                                        projectEnd: end
                                    })
                                }}
                                minDate={millisecToDatePicker(this.state.projectStart)}
                            />
                        </div>
                    </div>
                    <div>
                        <h2>Raportin ja kirjauksen tunnusnumero</h2>
                        <div className={"element-set valign-center"}>
                            {this.renderIdentifiersSwitch()}
                        </div>
                        {this.renderDelayForIdAutoGeneration()}
                        {this.renderResetOrAddNumbering()}
                    </div>
                </div>
                <Spacer line/>
                <div className="slab grid-container grid-1 grid-2_xl">
                    <div>
                        <h2>Lupa projektin tietojen jakamiseen</h2>
                        {this.renderInfoSharingSwitch(ATTR_EXPORT_WEB_REPORT_ACT, FEAT_WEB_ACTIVE, "Aktiiviset web raportit")}
                        {this.renderInfoSharingSwitch(ATTR_EXPORT_WEB_REPORT, FEAT_WEB_UPDATED, "Web raportit")}
                        {this.renderInfoSharingSwitch(ATTR_EXPORT_JSON, FEAT_JSON_EXPORT, "Projektin .json tiedostorajapinta")}
                        {this.renderInfoSharingSwitch(ATTR_IS_PICTURES_ALLOWED, undefined, "Kuvien käyttö sallittu")}
                        {this.renderInfoSharingSwitch(ATTR_IS_REPORTS_ALLOWED, undefined, "Raporttien luonti sallittu")}
                    </div>
                </div>
                <div className={"slab"}>
                    {this.renderProjectSettingsInfo()}
                </div>
            </section>
            {this.renderSaveCancelButtons()}
        </>
    }

    renderObsSettings(){
        const headerElementDueDate = <h3 className={"icon-text-set"}>
            <i className="ui-icon ui-icon-alarm" title="Myöhässä"/>
            <span>Määräajan asetukset</span>
        </h3>


        return   <>
            <h1>Kirjausten asetukset</h1>
            <section>
                <div className="slab">
                    <p>Projektin aikana voidaan lisätä uusia valintoja,
                        ottaa valinta tai vaihtoehto <i>pois käytöstä</i> ja muuttaa niiden nimiä.</p>
                    <p>Projektien valintoja ja vaihtoehtoja ei saisi <i>poistaa</i>,
                        kun projekti on jo otettu käyttöön, sillä vanhojen kirjausten valinnan merkitys muuttuisi.<br/>
                        Poistamisen sijaan ota valinta <i>pois käytöstä</i>.</p>
                        {this.renderDumpButton()}
                </div>
                <div className={"slab"}>
                    <AccordionDropdown
                       header={headerElementDueDate}
                    >
                        <div className={"grid-container grid-flex-4"}>
                            <div className={"custom-child-absolute"}><p title={"Rajoitetulla oikeuksilla oman kirjauksen määräaika"} className={"text-sm"}>Raj. oikeudet, oma kirjaus</p></div>
                            <div className={"custom-child-absolute"}><p title={"Muokkaus rajoitetulla oikeuksilla"} className={"text-sm"}>Muokkaus raj. oikeudet</p></div>
                            <div><p title={"Määräajan pakollisuus"} className={"text-sm"}>Pakollinen</p></div>
                            <div><p title={"Määräajan kellonaika"} className={"text-sm"}>Salli kellonajan asettaminen</p></div>
                            <div>{this.renderDueDateSwitch('dueDateRestrictedOwn')}</div>
                            <div>{this.renderDueDateSwitch('dueDateRestricted')}</div>
                            <div>{this.renderDueDateSwitch('dueDateMandatory')}</div>
                            <div>{this.renderDueDateSwitch('dueDateTime')}</div>
                        </div>
                    </AccordionDropdown>
                </div>
                <div className="slab">
                    <AccordionDropdown
                        header={<h3>Kyllä / ei valinnat</h3>}
                    >
                        <div className={"grid-container grid-flex-5"}>
                            <div><p title={"Valitse onko valinta käytössä"} className={"text-sm"}>Käytössä</p></div>
                            <div><p title={"Muuta valinnan nimeä"} className={"text-sm"}>Nimi</p></div>
                            <div className={"custom-child-absolute"}>{this.renderTitleWithRestrictedAccess()}</div>
                            <div><p title={"Valitse tiedon yhteydessä näytettävä kuvake"} className={"text-sm"}>Kuvake</p></div>
                            <div/>
                        </div>
                        {this.renderOnOffSelections()}
                        {this.renderAddNewOnOff()}
                    </AccordionDropdown>
                </div>
                <div className="slab">
                    <AccordionDropdown
                        header={<h3>Tekstikentät</h3>}
                    >
                        <div className={"grid-container grid-flex-6"}>
                            <div><p title={"Valitse onko valinta käytössä"} className={"text-sm"}>Käytössä</p></div>
                            <div><p title={"Muuta valinnan nimeä"} className={"text-sm"}>Nimi</p></div>
                            <div className={"custom-child-absolute"}>{this.renderTitleWithRestrictedAccess()}</div>
                            <div>{this.renderTitleMandatory()}</div>
                            <div/>
                            <div/>
                        </div>
                        {this.renderFreeText()}
                        <div>{this.renderAddNewText()}</div>
                    </AccordionDropdown>
                </div>
                <div className="slab">
                    <Spacer size={"lg"} />
                    <div className={"element-set"}>
                        <h3 className={"flex-grow"}>Monivalinnat</h3>
                        <BasicButton
                            label={"Järjestä valintoja"}
                            icon={"reorder"}
                            action={() => {
                                if (!this.state.isReorderingOptions) {
                                    prosNotificationShow(this,"Voit järjestellä vaihtoehtoja siirtämällä valinnan toisen päälle")
                                }
                                this.setState({isReorderingOptions: !this.state.isReorderingOptions})
                            }}
                            selected={this.state.isReorderingOptions}
                            disabled={!this.isAuthorized()}
                        />
                    </div>
                    <Spacer size={"sm"}/>
                    {this.renderMultiSelects()}
                    {this.renderAddNewMultiselect()}
                </div>
            </section>
            {this.renderSaveCancelButtons()}
        </>
    }

    renderSideBar(project) {
        return  <nav className={"side-nav settings-sidebar"}>
            <ul className={"navigation"}>
                {this.settingsNavigation(project.isProjectActive())}
                {this.renderExcelLinks()}
                {this.renderMoveProject(project.isProjectActive())}
                <Spacer line/>
                {this.renderToggleActivePassive(project)}
                {this.renderDeleteProject()}
            </ul>
        </nav>
    }

    renderSettingsSubpage(activeProject) {
        if (!this.state.activeSettingsPage ||
            this.state.activeSettingsPage === "settings") {
            return this.renderProjectSettings()
        }
        else if (this.state.activeSettingsPage === "obs-settings") {
            return this.renderObsSettings()
        }
        else if (this.state.activeSettingsPage === "projectDeletedData") {
            return <ProjectDeletedDataRestore
                projectName={this.state.projectName}
                mainProjectName={this.state.mainProjectName}
                closeView={this.goBack}
            />
        }
    else if (this.state.activeSettingsPage === "loctPicts") {
            return <SettingLocationPictures
                projectName={this.state.projectName}
                mainProjectName={this.state.mainProjectName}
            />
        }
        else if (this.state.activeSettingsPage === "excelExport") {
            return <ExcelImportExport
                closePage={() => this.setActivePage("settings") }
                notif={this.notifText}
            />
        }
        else if (this.state.activeSettingsPage === "moveProject") {
            return <SettingMoveProject
                closePage={() => this.setActivePage("settings") }
                mainProjectId={activeProject.getAttr(ATTR_MAIN_PROJ_ID)}
                customerGroup={activeProject.getAttr(ATTR_CUSTOMER_GROUP)}
                projectName={this.state.projectName}
                pid={this.state.projectId}
                mainProjectName={this.state.mainProjectName}
            />
        } else if (this.state.activeSettingsPage === "permissionGroups") {
            return <PermissionManagement
                closePage={() => this.setActivePage("settings") }
                notif={this.notifText}
                showSingleSubProject={true}
                subProjectId={prosConnect.getActiveProjectID()}
            />
        }
    }

    render() {
        require("./assets/scss/ProjectSettings.scss");
        if (this.state.isLoading) {
            return <LoadingAnimation size={"lg"} />
        }
        let activeProject = prosConnect.getActiveProject()
        if (!activeProject) {
            //session timed out..
            return <section>
                <Spacer size={"lg"}/>
                <div className={"msg msg-notice margin-auto width-100 width-50_lg width-30_hd"}>
                    <h3 className={"text-center"}>Ei valintaa</h3>
                    <footer>
                        <div className={"btn-set_center"}>
                            <BasicButton
                                btnClass={"2nd"}
                                label={"Palaa etusivulle"}
                                icon={"arrow-left"}
                                action={()=> this.goBack()}
                            />
                        </div>
                    </footer>
                </div>
            </section>
        }

        return <>
            <div className={"side-nav-container project-settings " + this.state.activeSettingsPage}>
                {this.renderSideBar(activeProject)}
                <div className={"side-nav-page"}>
                    {this.renderSettingsSubpage(activeProject)}
                </div>
            </div>
            {prosPopupRender(this, "ProjectSettings")}
        </>
    }
}

function IconPicker(props){
    const [selectedIcon, setSelectedIcon] = useState(props.currentIcon)
    return <div className={"btn-set"}>
        {userIconData.map((item, i) => {
            return <i
                key={i}
                onClick={()=> {
                    setSelectedIcon(i)
                    selectedUserIcon = i
                }}
                className={"btn ui-icon_set-user ui-icon ui-icon-" + item
                    + (selectedIcon === i ? " btn-state-selected" : "")
                }
            />
        })}
    </div>
}